import styled from "styled-components"

export const ExportDataStyle=styled.div`
    .export-div{
        position: absolute; 
        bottom: 0; 
        right: 0;
        margin-right:5vh;
        margin-bottom:5vh;
        display:flex;
        flex-direction:column;
    }
    .export-div2{
        position: fixed; 
        bottom: 0; 
        right: 0;
        margin-right:5vh;
        margin-bottom:38vh;
        display:flex;
        flex-direction:column;
    }

    .download-div{
        width:70px;
        height:70px;
        background-color:#f28809;
        display:flex;
        justify-content:center;
        flex-direction:row;
        align-item:center;
        border-radius:50%;
        margin-bottom:1vh;
        cursor:pointer;
    }

    .download-div2{
        width:70px;
        height:70px;
        background-color:#f28809;
        display:flex;
        justify-content:center;
        flex-direction:row;
        align-item:center;
        border-radius:50%;
        margin-bottom:10vh;
        cursor:pointer;
    }

    .diable-div{
        pointer-events: none;
    }

    .download-icon{
        font-size:32px;
        color:white;
        align-self:center;
    }
    .download-icon2{
        font-size:32px;
        color:white;
        align-self:center;
        transform: rotate(0deg);
        transition: transform 1s;
    }
    .download-icon-rotate{  
        font-size:32px;
        color:white;
        align-self:center;
        transform: rotate(180deg);
        transition: transform 1s;
    }
    .options-container {
        transition: 1 0.3s ease-in-out;
    }
    .hide{
        display:none;
    }

    /* For medium devices */
    @media screen and (max-width: 576px) {
        .download-div{
            width:60px;
            height:60px;
        }

        .download-icon2{
            font-size:28px;
        }
        .download-icon{
            font-size:28px;
        }
    }
`